<template>
  <div class="outmain heighthv pad_20 bor_rad5 ba_f">
    <div class="ba_f">
      <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>新建题目</span>
        </div>
      </div>
      <el-form :inline="true" :model="formInline">
        <el-form-item label="题目标题" class="mar_l20">
          <el-input style="width: 200px;" v-model="formInline.title" :placeholder="$t('plugin.learnings.title')" @input="getCollegeList"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="ba_f mar_t20 pad_20">
      <div class="t_l mar_b20">
        <el-button type="primary" size="medium" @click="handAddSubject(false)">新增题目</el-button>
      </div>
      <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="tableList" stripe style="width: 100%;" @selection-change="setSelectRows">
        <el-table-column prop="sort" label="排序" width="100" align="center"></el-table-column>
        <el-table-column prop="title" label="题目标题" align="center"></el-table-column>
        <el-table-column prop="storeName" label="答案选项" align="center">
          <template slot-scope="scope">
            <span class="color-green">{{ scope.row.answer }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="分数" align="center">
          <template slot-scope="scope">
            <span class="color_b">{{ scope.row.score }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" :label="$t('common.addTime')" align="center"></el-table-column>
        <el-table-column :label="$t('common.operation')" min-width="130" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handAddSubject(scope.row.id)">{{ $t('common.edit') }}</el-button>
            <el-button type="text" @click="handRemoveSubject(scope.row.id)">{{ $t('common.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.size" :current-page.sync="formInline.page" @current-change="handleCurrentChange"></el-pagination>
    </div>
    <learnings-add-subject ref="subject" v-if="SubjectShow" @callbackClose="callbackClose"></learnings-add-subject>
  </div>
</template>
<script>
import { collegeList, collegeDelete } from '@/api/plugins.js';
import LearningsAddSubject from './components/learnings-add-subject.vue';
export default {
  components: { LearningsAddSubject },
  data() {
    return {
      SubjectShow: false,
      listLoading: false,
      
      tableList: [],
      formInline: {
        id: '',
        page: 1,
        title: ''
      },
      page: {
        total: 0,
        size: 10
      }
    };
  },
  created() {
    this.formInline.id = this.$route.query.id;
    this.getCollegeList();
  },
  computed: {

    loadingText() {

      return this.$t('common.loading');

    },

  },

  methods: {
    // 关闭回调
    callbackClose() {
      this.SubjectShow = false;
      this.getCollegeList();
    },
    getCollegeList() {
      collegeList(this.formInline).then((res) => {
        if (res.code == 1) {
          this.tableList = res.data;
          this.page.total = res.count;
        }
      });
    },
    // 多选回�?
    setSelectRows() {},
    // 分页回调
    handleCurrentChange(msg) {
      this.formInline.page = msg;
      this.getCollegeList();
    },
    // 编辑
    handAddSubject(id) {
      this.SubjectShow = true;
      this.$nextTick(() => {
        this.$refs.subject.init(id, this.$route.query.id);
      });
    },
    // 删除
    handRemoveSubject(id) {
      this.$baseConfirm(this.$t('confirm.deleteItem'), null, () => {
        collegeDelete({ id }).then((res) => {
          if (res.code == 1) {
            this.$baseMessage(res.msg, 'success');
            this.getCollegeList();
          }
        });
      });
    }
  }
};
</script>
